import { render, staticRenderFns } from "./WflowTodo.vue?vue&type=template&id=13363e75"
import script from "./WflowTodo.vue?vue&type=script&lang=js"
export * from "./WflowTodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports